<template>
    <section>
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="mx-auto">
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title class="flex"><img src="@/assets/ares.png" height="50px" width="50px"
                                    class="mr-8" />ARES<span class="ml-8">Reset password</span> </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text v-if="showForm === true">
                            <v-form ref="form" v-model="valid">
                                <v-text-field label="New Password" v-model="gebr.password"
                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'"
                                    prepend-icon="mdi-key-variant" :rules="[passwordRules]" @click:append="show = !show"
                                    required></v-text-field>
                                <v-text-field label="Re-enter new Password" v-model="gebr.reenteredPassword"
                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" prepend-icon="mdi-key-variant"
                                    :type="show1 ? 'text' : 'password'" :rules="[passwordRules, passwordConfirmationRule]"
                                    @click:append="show1 = !show1" required></v-text-field>

                            </v-form>
                        </v-card-text>
                        <v-card-actions v-if="showForm === true">
                            <div class="flex-grow-1"></div>
                            <v-btn color="success" :disabled="!valid" @click="doPasswordReset">Change my password</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <standard_dialog ref="std_dialog" />
        </v-container>
    </section>
</template>

<script>
import standard_dialog from '@/components/ui/standard_dialog.vue';

export default {
    components: {
        standard_dialog,
    },
    props: {
        link_encrid: String,
    },
    data() { 
        return {
            valid: true,
            loginId: "",
            show: false,
            show1: false,
            snackbar: false,
            showForm: true,
            gebr: {},
            passwordRules: value => {
                const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.{8,})/;
                return (
                    pattern.test(value) ||
                    "Min. 8 characters with at least one capital letter"
                );
            },
            error_message: ""
        }
    },
    mounted() {
        this.$axios
            .post("ares/json/ares/syst/gebr/getGebrToResetPassword.p", {
                header: {
                    request: "getGebrToResetPassword"
                },
                getGebrToResetPassword: {
                    link_encrid: this.link_encrid
                }
            })
            .then(res => {
                if (res.data.error) {
                    this.$refs.std_dialog.open('error', 'Error', res.data.error.message);
                    this.showForm = false;
                } else {
                    this.gebr = res.data.getGebrToResetPassword;
                    if (res.data.getGebrToResetPassword.color == "error") {
                        this.showForm = false;
                        this.$refs.std_dialog.open('error', 'Error', res.data.getGebrToResetPassword.text);
                    }
                }
            });
    },
    methods: {
        reset() {
            this.$refs.form.reset();
        },
        doLogin(user, password) {
            console.log('u/p', user, password);
            this.$session.start();
            this.$axios
                .post("ares/json/ares/misc/login.p", {
                    loginId: user,
                    password: password,
                    clientSessionId: this.$session.id()
                })
                .then(response => {
                    if (response.data.token !== "LoginError") {
                        localStorage.setItem('login', user);
                        this.$session.set("ARES", response.data.token);
                        this.$router.push(response.data.dashboard);
                        //this.loginId === 'hans' ? this.$router.push("/dashBoardHans") : this.$router.push("/dashBoard");
                    } else {
                        this.$refs.std_dialog.open('error', 'Error', 'Login incorrect');
                        this.$session.destroy();
                    }
                })
        },
        doPasswordReset() {
            this.$session.start();
            this.$axios
                .post("ares/json/ares/syst/gebr/getGebrToResetPassword.p", {
                    header: {
                        request: "getGebrToResetPassword"
                    },
                    getGebrToResetPassword: {
                        password: this.gebr.password,
                        link_encrid: this.link_encrid
                    }
                })
                .then(res => {
                    if (res.data.getGebrToResetPassword.color == "success") {
                        this.showForm = false;
                        this.$session.destroy();
                        this.doLogin(res.data.getGebrToResetPassword.gebr_code, this.gebr.password);
                    } else
                        setTimeout(() => {
                            this.showForm = false;
                            this.$session.destroy();
                            this.$router.push("/");
                        }, 3000);
                })
        },
    },
    computed: {
        passwordConfirmationRule() {
            return this.gebr.password === this.gebr.reenteredPassword || "Password must match";
        }
    }
}
</script>
<style scoped>
.flex {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>